import { pStyle } from './ConfigStyle';
import React, { Fragment } from 'react';
import MissingReupload from '../../containers/ReuploadOnline';
import { ThreeDotsLoading } from './../components/three-dot-loading/index';

const WaitingProccess = ({ loadingState }) => {
  const { defaultMess, receiveMessage, isOffline, isReceiveComponent } =
    !!loadingState && loadingState;

  return (
    <section id="waitingProccess" className="animate-bottom">
      <div className="alignCenter">
        <div
          className="borderNone"
          style={{
            position: 'relative',
            padding: '10px',
          }}
        >
          {isReceiveComponent ? (
            <MissingReupload isOffline={isOffline} />
          ) : (
            <Fragment>
              <Fragment>
                {defaultMess && (
                  <p className="animate-bottom" style={pStyle}>
                    {defaultMess}
                  </p>
                )}

                <div
                  style={{
                    position: 'relative',
                    top: '20px',
                  }}
                >
                  <ThreeDotsLoading
                    size={15} // Optional: customize dot size
                    color="#27d089" // Optional: customize dot color
                  />
                </div>
              </Fragment>
              <Fragment>
                {receiveMessage && (
                  <div style={{ color: '#fff', textAlign: 'center' }}>
                    {receiveMessage}
                  </div>
                )}
              </Fragment>
            </Fragment>
          )}
        </div>
      </div>
      <div className="overlay-bg-blur" />
    </section>
  );
};

export default React.memo(WaitingProccess);
